// Investiture
import React from 'react';
import { Kannadacca1class2026 } from '../views';


const InvestiturePage = () => {
  return <Kannadacca1class2026 />;
};

export default InvestiturePage;
